import { useCallback } from 'react';
import { useIsInBottomSheet } from '../../../providers/IsInBottomSheetProvider';
import { useSheetStack } from './useSheetStack';
/**
 * Returns a dismisser for the managed bottom sheet containing this content — the sheet-level
 * counterpart of a modal's dismissModal. No-ops when not rendered inside the managed sheet.
 */ export function useDismissBottomSheet() {
    const { hideBottomSheet } = useSheetStack();
    const isInBottomSheet = useIsInBottomSheet();
    return useCallback(()=>{
        if (!isInBottomSheet) return;
        hideBottomSheet();
    }, [
        isInBottomSheet,
        hideBottomSheet
    ]);
}
